import React, {useState} from 'react';
import {Tabs, PageHeader} from 'antd';
import styles from '../index.module.less';
import TransferTable from '@/page/customer/TransferPage/TransferTable';

const {TabPane} = Tabs;

export default function TransferPage() {
    const [title, setTitle] = useState('在职交接');

    function changeTabs(e) {
        switch (e) {
            case '1':
                setTitle('在职交接');
                break;
            case '2':
                setTitle('离职交接');
                break;
            case '3':
                setTitle('群组交接');
                break;
        }
    }

    return (
        <div style={{overflowY: 'auto'}}>
            <PageHeader title={title} />
            <div className={styles.tableContainer}>
                <Tabs defaultActiveKey="1" onChange={changeTabs} className={styles.container}>
                    <TabPane tab="在职交接" key="1">
                        <TransferTable />
                    </TabPane>
                    <TabPane tab="离职交接" key="2">
                        <TransferTable transferType="2" />
                    </TabPane>
                    <TabPane tab="群组交接" key="3">
                        <TransferTable transferType="2" isRoom="1" />
                    </TabPane>
                </Tabs>
            </div>
        </div>
    );
}
